import { Model } from '@vuex-orm/core'
import ArticleHasFeature from '@models/helpers/ArticleHasFeature'

export default class Feature extends Model{
  static entity = 'features'
  static fields () {
    return {
      id: this.attr(null),
      label: this.attr(null),
      unit_id: this.attr(null),
      articles: this.hasMany(ArticleHasFeature, 'feature_id'),
    }
  }
}
  